import React, { useState } from 'react'
import logo from '../assets/Navbar/logo.png'
import otpimg from '../assets/otp/otp.png'
import { useNavigate, useLocation, } from "react-router-dom";



function Otp(props) {
    const [code, setCode] = useState(new Array(4).fill(''));
    const [otp, setOtp] = useState('');
    const location = useLocation();
    const { username, password } = location.state || {};
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const handleChange = (element, index) => {
        const value = element.value.replace(/\D/, ''); // Allow only numeric input
        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        // Move to the next input field if a number is entered
        if (value && element.nextSibling) {
            element.nextSibling.focus();
        }
    };

    const handleKeyDown = (element, index) => {
        // Move to the previous input field if backspace is pressed and the current field is empty
        if (element.key === 'Backspace' && !element.target.value && element.target.previousSibling) {
            element.target.previousSibling.focus();
        }
    };

    const navigate = useNavigate();



    const handleOtpChange = (event) => {
        setOtp(event.target.value);
    };

    const handleOtpVerification = () => {
        const enteredOtp = code.join(""); // join 4 digits into one string

        const apiUrl = `${apiBaseUrl}/user/Verify/JAPAN_ACCESORIES`;
        const url = `${apiUrl}?username=${username}&password=${password}&otp=${enteredOtp}`;

        fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data.message && data.message[0] && data.message[0][''] === 'Verification Success') {
                    alert("Verification successful");
                    navigate('/');
                } else {
                    alert('OTP verification failed. Please try again.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };




    return (
        <div className='w-[100vw] h-[100vh]  flex flex-col'>
            <div className='h-[80px] px-5 lg:px-12 w-full flex justify-start items-center '>
                <img src={logo} alt='logo' />
            </div>
            <div className='w-[100%] h-[100%] flex flex-row '>
                <div className='w-[100%] lg:w-[50%] h-[100%] flex justify-center items-start px-[8%]  flex-col gap-10'>
                    <span className='font-display text-4xl text-[500] flex flex-col gap-3'>Enter the code
                        <span className='font-display text-xl text-[400] '>Please Contact ALIK STORE for OTP<br />be careful not to share with any one.
                        </span>
                    </span>
                    <div className='flex flex-row gap-5'>
                        {code.map((digit, index) => (
                            <input
                                key={index}
                                type='text'
                                maxLength='1'
                                value={digit}
                                onChange={(e) => handleChange(e.target, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                className='w-12 h-11 border-2 border-[#D7D7D7] rounded-[5px] text-center text-xl'
                            />
                        ))}

                    </div>
                    <div className='w-[80%] h-[55px] rounded-[5px] bg-[#8B0000] text-2xl text-[600] font-display flex justify-center items-center text-[white] cursor-pointer' onClick={handleOtpVerification}>Verify</div>

                </div>
                <div className='w-[50%] h-[100%] justify-center items-center hidden lg:flex'>
                    <div className='w-[519px] h-[508px] '>
                        <img src={otpimg} alt='otp' style={{ height: '100%', width: '100%' }} />
                    </div>
                </div>

            </div>

        </div>
    )
}

export default Otp